import { Platform } from 'react-native';
import { createURL } from 'expo-linking';

/** Scopes approved on the production LinkedIn app. American spelling is required. */
export const LINKEDIN_OAUTH_SCOPES = [
	'openid',
	'profile',
	'email',
	'w_member_social',
	'r_organization_social',
	'rw_organization_admin',
	'w_organization_social',
	'r_1st_connections_size',
] as const;

export const LINKEDIN_OAUTH_SCOPE = LINKEDIN_OAUTH_SCOPES.join(' ');

/** Allowlisted on the production LinkedIn app. */
export const LINKEDIN_PRODUCTION_WEB_REDIRECT = 'https://smartsaas.pro/universal/integrations';
export const LINKEDIN_PRODUCTION_NATIVE_REDIRECT = 'https://api.smartsaas.pro/app-redirect';

const LEGACY_LINKEDIN_SCOPES: Record<string, string> = {
	r_liteprofile: 'profile',
	r_emailaddress: 'email',
};

export function normalizeLinkedInScopes(scopes: string[] | undefined | null): string[] {
	const source = Array.isArray(scopes) ? scopes : [];
	const normalized = source
		.map((scope) => {
			const raw = String(scope || '').trim();
			if (!raw) return '';
			return LEGACY_LINKEDIN_SCOPES[raw] || raw.replace(/organisation/g, 'organization');
		})
		.filter(Boolean);
	const unique = [...new Set(normalized)];
	return unique.length ? unique : [...LINKEDIN_OAUTH_SCOPES];
}

function redirectHostname(candidate: string): string {
	const match = candidate.match(/^[a-z][a-z0-9+.-]*:\/\/([^/?#]+)/i);
	if (!match) return '';
	let authority = match[1];
	if (authority.startsWith('[')) {
		const end = authority.indexOf(']');
		return end >= 0 ? authority.slice(1, end) : '';
	}
	const colon = authority.lastIndexOf(':');
	if (colon > -1 && /^\d+$/.test(authority.slice(colon + 1))) {
		authority = authority.slice(0, colon);
	}
	return authority;
}

/**
 * Keep localhost and the apex production host. Other hosts (www, app.smartsaas.co.uk)
 * are not on the LinkedIn redirect allowlist, so send those through the allowlisted URL.
 */
export function resolveLinkedInWebRedirect(candidate: string | undefined | null): string {
	if (!candidate) return LINKEDIN_PRODUCTION_WEB_REDIRECT;
	const host = redirectHostname(candidate);
	if (host === 'localhost' || host === '127.0.0.1' || host === 'smartsaas.pro') {
		return candidate;
	}
	return LINKEDIN_PRODUCTION_WEB_REDIRECT;
}

export function getLinkedInOAuthRedirectUri(): string {
	if (Platform.OS !== 'web') return LINKEDIN_PRODUCTION_NATIVE_REDIRECT;
	return resolveLinkedInWebRedirect(createURL('/universal/integrations'));
}
